import * as APIStore from "../../store/APIStore";


export const shouldTryRefMDProfile = (userRefMDProfile: APIStore.RefMDProfileState) => {

    if (!userRefMDProfile) {
        return true;
    }

    let { isLoaded, notFound, isErrored, isLoading } = userRefMDProfile;

    if(isLoaded || isLoading || isErrored || notFound) {
        return false;
    }

    return true;
}

export const shouldTryCareCoordinatorProfile = (userPracticeCoordinatorProfile: APIStore.PracticeCoordinatorState) => {

    if (!userPracticeCoordinatorProfile) {
        return true;
    }

    let { isLoaded, notFound, isErrored, isLoading } = userPracticeCoordinatorProfile;

    if(isLoaded || isLoading || isErrored || notFound) {
        return false;
    }

    return true;
}



export const refMDLoaded = (userRefMDProfile: APIStore.RefMDProfileState) => {

    if (!userRefMDProfile) {
        return false;
    }

    let { isLoaded, notFound } = userRefMDProfile;

    if(isLoaded) {
        return true;
    }

    if (!isLoaded || !notFound) {
        return false;
    }

    return true
}

export const practiceCoordinatorLoaded = (userPracticeCoordinatorProfile: APIStore.PracticeCoordinatorState) => {

    if (!userPracticeCoordinatorProfile) {
        return false;
    }

    let { isLoaded, notFound } = userPracticeCoordinatorProfile;

    if(isLoaded) {
        return true;
    }

    if (!isLoaded) {
        return false;
    }

    if (!isLoaded || !notFound) {
        return false;
    }

    return true
}